export default {
  fr: { 'number.separator': ' ' },
  en: { 'number.separator': ',' },
  'pt-br': { 'number.separator': '.' },
  es: { 'number.separator': '' },
  de: { 'number.separator': '.' },
} as const
